import { Controller } from "@hotwired/stimulus"
import { openSheet, openDocument } from "../sheet_viewer"

// A read file's chip in the chat (_upload_chip): opens it in the sheet viewer rather than
// downloading it. The chip's own href is the download, which the viewer's header keeps.
export default class extends Controller {
  static values = { json: String, title: String, ext: String }

  open(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey) return // a modified click still downloads
    event.preventDefault()
    if (['docx', 'pptx'].includes(this.extValue)) { // page by page, as a document PharOS built
      openDocument({ title: `${this.titleValue}.${this.extValue}`, jsonUrl: this.jsonValue, downloadUrl: this.element.href })
      return
    }
    openSheet({ title: this.titleValue, jsonUrl: this.jsonValue, downloadUrl: this.element.href, ext: this.extValue })
  }
}
